"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  // 1. Effets de bord
  // --
  // 2. Informations globales
  // --
  name: 'NotificationList',
  // 3. Type de composant
  // --
  // 4. Modificateurs de template
  // --
  // 5. Dépendances des templates
  // --
  // 6. Composition
  // --
  // 7. Interface (interface du composant)
  // --
  // 8. État local (propriétés réactives locales)
  // --
  data: function data() {
    return {
      columns: [{
        prop: 'num_affaire',
        label: 'N° Affaire',
        width: '100'
      }, {
        prop: 'message',
        label: 'Message'
      }, {
        prop: 'date_creation',
        label: 'Date'
      }],
      filterReadStatus: [{
        text: 'Lu',
        value: 'read'
      }, {
        text: 'Non Lu',
        value: 'unread'
      }],
      filters: [{
        value: '',
        prop: ['message']
      }],
      multipleSelection: [],
      refresh: 0,
      total: 0
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['notifications', 'user'])),
  // 9. Évènements
  // --
  // 10. Propriétés non réactives
  // --
  methods: {
    filterHandler: function filterHandler(value, row, column) {
      var property = column['property'];

      switch (value) {
        case 'read':
          return row[property] !== null;

        case 'unread':
          return row[property] === null;
      }
    },
    colWidth: function colWidth(index) {
      // permet de gérer indépendamment la largeur de chaque colonne en fonction de leur index
      switch (index) {
        case 0:
          return 350;

        case 2:
          return 200;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteSelection: function handleDeleteSelection() {
      var _this = this;

      var msg = this.multipleSelection.length > 1 ? 'les lignes sélectionnées' : 'la ligne sélectionnée';
      this.$confirm('Voulez-vous supprimer ' + msg + ' ?', 'Confirmer la suppression', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('notifications/markasdeleted', _this.multipleSelection);

              case 2:
                _context.next = 4;
                return _this.$store.dispatch('notifications/read', _this.user.id);

              case 4:
                _this.refresh++;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleMarkAllAsRead: function () {
      var _handleMarkAllAsRead = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$store.dispatch('notifications/markallasread', this.user.id);

              case 2:
                _context2.next = 4;
                return this.$store.dispatch('notifications/read', this.user.id);

              case 4:
                this.refesh++;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleMarkAllAsRead() {
        return _handleMarkAllAsRead.apply(this, arguments);
      }

      return handleMarkAllAsRead;
    }()
  } // 11. Rendu
  // --

};
exports.default = _default;